export default "__VITE_PUBLIC_ASSET__dc4d6b7e__"